import style from "./preloader.module.scss";
/**
 * Implements a bouncing-ball preloader
 *
 * @param {string} textUnderAnimation - optional text under the bouncing balls
 * @param {string} textUnderAnimationCSSClasses - optional css casses to add to the text under the bouncing balls
 * @param {string} id - optional compontent/css id
 * @param {string} className - optional css classes
 * @param {string} size - animation footprint; "small" fits inline next to controls
 */
export default function Preloader({
  id,
  className = "",
  size = "default",
  textUnderAnimation,
  textUnderAnimationCSSClasses = "",
}: PreloaderProps) {
  return (
    <div id={id} className={`${style.Preloader} ${className}`}>
      <div className={`${style.ldsTyping} ${size === "small" ? style.small : ""}`}>
        <div className={style.ball1}></div>
        <div className={style.ball2}></div>
        <div className={style.ball3}></div>
        <div className={style.ball4}></div>
      </div>
      {textUnderAnimation && (
        <div className={`${style.text} ${textUnderAnimationCSSClasses}`}>{textUnderAnimation}</div>
      )}
    </div>
  );
}

export interface PreloaderProps {
  size?: "default" | "small";
  textUnderAnimation?: string;
  textUnderAnimationCSSClasses?: string;
  id?: string;
  className?: string;
}
